import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import AppFilesPage from "./AppFilesPage";
import AppFileCreatePage from "./AppFileCreatePage";
import AppFileEditPage from "./AppFileEditPage";

export default (
  <Route path="app-files">
    <Route
      index
      element={
        <Protected
          path="/admin/app-files"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <AppFilesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/app-files/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <AppFileCreatePage />
        </Protected>
      }
    />
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/app-files/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <AppFileEditPage />
        </Protected>
      }
    />
  </Route>
);
